<template>
  <div class="input-bool">
    <label
      class="subtitle-1"
      v-if="renderLabel">
      {{ renderLabel }}
    </label>
    <v-radio-group
      v-model="selectedValue"
      row>
      <v-radio
        label="Ja"
        :value="true"
        @mouseup="mouseUpJa"
      />
      <v-radio
        label="Nein"
        :value="false"
        @mouseup="mouseUpNein"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'FilterBool',

  props: {
    filterQuestion: {
      type: Object,
      required: true
    }
  },

  computed: {
    renderLabel () {
      return this.filterQuestion.form_label
    },
    selectedValue: {
      get () { return this.$store.getters['getFilterAnswer'](this.filterQuestion.key) },
      set (value) {
        this.$store.commit('setFilterAnswer', {
          questionKey: this.filterQuestion.key,
          value
        })
      }
    }
  },

  methods: {
    isValueTypeValid (value) {
      return typeof value === 'boolean'
    },

    mouseUpJa () {
      if (this.selectedValue === true) {
        setTimeout(() => {
          this.selectedValue = undefined
        }, 50)
      }
    },

    mouseUpNein () {
      if (this.selectedValue === false) {
        setTimeout(() => {
          this.selectedValue = undefined
        }, 50)
      }
    }
  }
}
</script>

<style lang="scss">
  .input-bool {
    .v-input--radio-group {
      margin-top: 0.2em;
      margin-bottom: 0.4em;
    }
  }
</style>
